var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPdf32(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 28.75a.75.75 0 010-1.5h16c.69 0 1.25-.56 1.25-1.25V11H21a2 2 0 01-2-2V4.75h-9c-.69 0-1.25.56-1.25 1.25v4a.75.75 0 01-1.5 0V6A2.75 2.75 0 0110 3.25h9.998a.75.75 0 01.53.22l6.002 5.998c.141.14.22.331.22.53V26A2.75 2.75 0 0124 28.75H8z",
    fill: "#0E1C3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 13a2 2 0 00-2 2v8a2 2 0 002 2h15a2 2 0 002-2v-8a2 2 0 00-2-2H5zm1.802 7.083c1.17 0 1.944-.63 1.944-1.8 0-1.179-.774-1.809-1.944-1.809h-2.25V22h1.143v-1.917h1.107zm.81-1.8c0 .477-.288.819-.882.819H5.695v-1.647H6.73c.594 0 .882.333.882.828zm3.548 2.7v-3.501h.765c1.053 0 1.63.675 1.63 1.755 0 1.071-.577 1.746-1.63 1.746h-.765zM10.017 22h1.953c1.674 0 2.727-1.08 2.727-2.763 0-1.683-1.053-2.763-2.727-2.763h-1.953V22zm7.128-2.115V22h-1.143v-5.526h3.68v1.008h-2.537v1.404h2.349v.999h-2.35z",
    fill: "#FD597B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPdf32);
export default __webpack_public_path__ + "static/media/icon-pdf-32.c5a8b2c8.svg";
export { ForwardRef as ReactComponent };